import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 井盖列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	manholeList( params={} ) {
		return request({
	    url: baseUrl + '/device/manhole',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 井盖详情
	 * @param {manhole_id} 井盖id
	**/
	manholeInfo(id) {
		return request({
	    url: baseUrl + '/device/manholeInfo/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 井盖添加
	**/
	manholeAdd(data){
		return request({
			url: baseUrl + '/device/manhole',
			method:'POST',
			data
		})
	},

	/**
	 * 井盖编辑
	**/
	manholeEdit(id,data){
		return request({
			url: baseUrl + '/device/manhole/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 井盖删除
	**/
	manholeDel(id){
		return request({
			url: baseUrl + '/device/manhole/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 井盖设防
	 * @return {type} 1打开2松动3复位
	**/
	manholeSet(id,data){
		return request({
			url: baseUrl + '/device/manhole/control/'+id,
			method:'POST',
			data
		})
	},
}